import React from "react";
import PropTypes from "prop-types";
import Read from "../models/Read";

function ReadTitle(props) {
  const { item, actions } = props;
  const chr = item.region.chromosome;
  return item ? (
    <>
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">
          {chr.name}:{item.region.x0}..{item.region.x1}
        </div>
        {actions}
      </div>

      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Observed Read Ratio</div>
        <div className="tw-flex-grow">
          {Math.round(item.readratio * 100) / 100}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Expected Ratio Range</div>
        <div className="tw-flex-grow">
          [{Math.round(item.min * 100) / 100},{" "}
          {Math.round(item.max * 100) / 100}]
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Read Start Position</div>
        <div className="tw-flex-grow">
          {item.region.chromosome.name}: {item.region.x0.toLocaleString()}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Read End Position</div>
        <div className="tw-flex-grow">
          {item.region.chromosome.name}: {item.region.x1.toLocaleString()}
        </div>
      </div>
      <div className="tooltip-row">
        <div className="tooltip-label tw-w-36">Read Length</div>
        <div className="tw-flex-grow">
          {(item.region.g1 - item.region.g0).toLocaleString()}
        </div>
      </div>
    </>
  ) : null;
}

ReadTitle.propTypes = {
  item: PropTypes.instanceOf(Read).isRequired,
  actions: PropTypes.node,
};

ReadTitle.defaultProps = {
  actions: null,
};

export default ReadTitle;
